import {Component, OnInit, signal} from '@angular/core';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {Router, RouterLink} from '@angular/router';
import {CordovaService} from '../../cordova.service';
import {CustomerArea} from '../../classes/customerarea.class';
import {CustomerAreaService} from '../../services/consumer-area/customer-area.service';
import {CodaltComponent} from '../../codalt.component';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";

@Component({
    selector: 'app-customer-area-overview',
    templateUrl: './customer-area-overview.component.html',
    styleUrls: ['./customer-area-overview.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatIconButton,
        MatButton
    ]
})
export class CustomerAreaOverviewComponent extends CodaltComponent implements OnInit {

    readonly customerAreas = signal<CustomerArea[]>([]);
    readonly currentSort = signal<string>(null);
    readonly desc = signal<boolean>(false);
    readonly exporting = signal<boolean>(false);

    constructor(
        private customerAreaService: CustomerAreaService,
        private router: Router,
        private cordovaService: CordovaService,
        private confirmDialog: ConfirmDialogService
    ) {
        super();
    }

    ngOnInit() {
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        this.customerAreaService.getList().then(customerAreas => {
            this.customerAreas.set(customerAreas);
            this.sortList('name');
        });
    }

    deleteCustomerArea(event, customerArea) {
        event.preventDefault();
        event.stopPropagation();
        this.confirmDialog.confirm('Verwijderen',
            `Weet u zeker dat u het klantgebied ${customerArea.name} wilt verwijderen?`, 'Ja').then(() => {
            this.customerAreaService.delete(customerArea.id).then(result => {
                const index = this.customerAreas().indexOf(customerArea);
                this.customerAreas().splice(index, 1);
            });
        });
    }

    public sortList(sortingOn) {
        let customerAreas = this.customerAreas();
        this.customerAreas.set([]);

        if (sortingOn === this.currentSort()) {
            customerAreas = customerAreas.reverse();
            this.desc.set(!this.desc());
        } else {
            this.desc.set(false);
            customerAreas = customerAreas.sort((a, b) => {
                if (a[sortingOn].toUpperCase() < b[sortingOn].toUpperCase()) {
                    return -1;
                }
                if (a[sortingOn].toUpperCase() > b[sortingOn].toUpperCase()) {
                    return 1;
                }
                return 0;
            });
        }

        this.customerAreas.set(customerAreas);

        this.currentSort.set(sortingOn);
    }
}
